export const option ={
  "industries": [
    {"label": "Arts", "value": "arts"},
    {"label": "Construction", "value": "construction"},
    {"label": "Consulting", "value": "consulting"},
    {"label": "Consumer Goods", "value": "consumerGoods"},
    {"label": "Critical Infrastructure", "value": "criticalInfrastructure"},
    {"label": "Distribution", "value": "distribution"},
    {"label": "Education", "value": "education"},
    {"label": "Electronics", "value": "electronics"},
    {"label": "Energy/Utilities", "value": "energyUtilities"},
    {"label": "Engineering", "value": "engineering"},
    {"label": "Entertainment", "value": "entertainment"},
    {"label": "Environmental", "value": "environmental"},
    {"label": "Facilities Services", "value": "facilitiesServices"},
    {"label": "Financial Services", "value": "financialServices"},
    {"label": "Food and Agriculture", "value": "foodAndAgriculture"},
    {"label": "Health Services", "value": "healthServices"},
    {"label": "Industrial", "value": "industrial"},
    {"label": "Information Technology", "value": "informationTechnology"},
    {"label": "Insurance", "value": "insurance"},
    {"label": "IT Infrastructure", "value": "itInfrastructure"},
    {"label": "IT Services", "value": "itServices"},
    {"label": "Law", "value": "law"},
    {"label": "Manufacturing", "value": "manufacturing"},
    {"label": "Media Entertainment", "value": "mediaEntertainment"},
    {"label": "Mining", "value": "mining"},
    {"label": "Not-for-profit", "value": "notForProfit"},
    {"label": "Pharmaceuticals", "value": "pharmaceuticals"},
    {"label": "Professional Services", "value": "professionalServices"},
    {"label": "Public Sector", "value": "publicSector"},
    {"label": "Real Estate", "value": "realEstate"},
    {"label": "Research", "value": "research"},
    {"label": "Retail", "value": "retail"},
    {"label": "Sports", "value": "sports"},
    {"label": "Technology", "value": "technology"},
    {"label": "Telecommunications", "value": "telecommunications"},
    {"label": "Transportation Logistics", "value": "transportationLogistics"},
    {"label": "Travel", "value": "travel"},
    {"label": "Translation and Localization", "value": "translationAndLocalization"},
    {"label": "Government Agency", "value": "governmentAgency"}
  ],
  "platforms": [
    {"label": "EMC Documentum", "value": "emcDocumentum"},
    {"label": "Entra ID", "value": "entraId"},
    {"label": "File System", "value": "fileSystem"},
    {"label": "Lotus Notes", "value": "lotusNotes"},
    {"label": "Microsoft Azure Cloud", "value": "microsoftAzureCloud"},
    {"label": "Microsoft Dynamics", "value": "microsoftDynamics"},
    {"label": "Microsoft Exchange Online", "value": "microsoftExchangeOnline"},
    {"label": "Microsoft Exchange Server Public Folders", "value": "microsoftExchangeServerPublicFolders"},
    {"label": "Microsoft OneDrive for Business", "value": "microsoftOnedriveForBusiness"},
    {"label": "Windows Server 2012", "value": "windowsServer2012"},
    {"label": "Microsoft SharePoint", "value": "microsoftSharepoint"},
    {"label": "Microsoft Viva Engage", "value": "microsoftVivaEngage"},
    {"label": "Microsoft 365", "value": "microsoft365"},
    {"label": "OpenText LiveLink", "value": "opentextLivelink"},
    {"label": "SharePoint 2010", "value": "sharepoint2010"},
    {"label": "SharePoint 2013", "value": "sharepoint2013"},
    {"label": "SharePoint 2016", "value": "sharepoint2016"},
    {"label": "SharePoint Server 2013", "value": "sharepointServer2013"},
    {"label": "SharePoint Online", "value": "sharepointOnline"},
    {"label": "SQL Server 2014", "value": "sqlServer2014"},
    {"label": "Salesforce", "value": "salesforce"},
    {"label": "Dynamics 365", "value": "dynamics365"},
    {"label": "Google Classroom", "value": "googleClassroom"},
    {"label": "Google Workspace", "value": "googleWorkspace"},
    {"label": "Power Platform", "value": "powerPlatform"},
    {"label": "Microsoft Azure", "value": "microsoftAzure"},
    {"label": "AWS", "value": "aws"}
  ],
  "regions": [
    {"label": "Asia", "value": "asia"},
    {"label": "Australia/New Zealand", "value": "australiaNewZealand"},
    {"label": "Europe", "value": "europe"},
    {"label": "Middle East/Africa", "value": "middleEastAfrica"},
    {"label": "North America", "value": "northAmerica"},
    {"label": "Japan", "value": "japan"}
  ]
}